import type { ThemeUICSSObject } from 'theme-ui';

/**
 * This can be used to reset the styles of a link in a "sx" property.
 *
 * Use only when necessary. The proper approach to buttons should be to use the button components provided by the library.
 *
 * @doc $DOC:button
 */
export const linkResetStyles: ThemeUICSSObject = {
	textDecoration: 'none',
	color: 'inherit',
	fontFamily: 'inherit',
	fontSize: 'inherit',
	fontWeight: 'inherit',
	lineHeight: 'inherit',
};
